<template>
  <div class="">
    <div class="col-12">
      <b-row>
        <b-col
          cols="12"
          class="d-md-none search-mobile-filters"
          v-if="!noFilters"
        >
          <b-button @click="toggleFilters()" variant="primary">
            Filter Results
            <span v-if="totalActiveFilters > 0"
              >({{ totalActiveFilters }})</span
            >
          </b-button>

          <b-form-select
            id="search-sort-by"
            v-model="sortBy"
            :options="[
              { value: 'default', text: 'Relevance' },
              { value: 'priceasc', text: 'Price (Low to High)' },
              { value: 'pricedesc', text: 'Price (High to Low)' },
              { value: 'vintage', text: 'Vintage (Most recent)' },
            ]"
            @change="changeSort()"
            class="search-sort-by"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row class="text-left search-header" v-if="displayMode === 'normal'">
        <b-container>
          <b-row>
            <b-col cols="5" v-if="!noFilters">
              <span v-if="performingSearch">Searching...</span>
              <span v-else>
                {{
                  results.total === 1
                    ? "" + results.total + " Item"
                    : "" + results.total + " Items"
                }}
              </span>
            </b-col>

            <b-col class="text-right" v-if="!noFilters">
              <label for="search-per-page">Show</label>
              <b-button
                variant="link"
                @click="
                  perPage = 20;
                  doSearch(false, true);
                "
                >20</b-button
              >

              <b-button
                variant="link"
                @click="
                  perPage = 40;
                  doSearch(false, true);
                "
                >40</b-button
              >

              <b-button
                variant="link"
                @click="
                  perPage = 60;
                  doSearch(false, true);
                "
                >60</b-button
              >

              <b-button
                variant="link"
                @click="
                  perPage = 100;
                  doSearch(false, true);
                "
                >100</b-button
              >

              <b-form-select
                v-if="!noFilters"
                v-model="sortBy"
                :options="[
                  { value: 'default', text: 'Relevance' },
                  { value: 'priceasc', text: 'Price (Low to High)' },
                  { value: 'pricedesc', text: 'Price (High to Low)' },
                  { value: 'vintage', text: 'Vintage (Most recent)' },
                ]"
                @change="changeSort()"
                class="search-sort-by"
              ></b-form-select>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
      <div
        class="duty-bar"
        v-if="
          !noFilters &&
          searchFacade !== 'spirits' &&
          !isTrade &&
          displayMode === 'normal'
        "
      >
        <b-row>
          <b-col>
            <b-button-group>
              <b-button
                @click="
                  filter.DutyType.val = 'DP';
                  dispatchDutyChangeEvent('DP');
                  doSearch(false, true);
                "
                :class="{ selected: filter.DutyType.val === 'DP' }"
                >Retail</b-button
              >
              <b-button
                @click="
                  filter.DutyType.val = 'IB';
                  dispatchDutyChangeEvent('IB');
                  doSearch(false, true);
                "
                :class="{ selected: filter.DutyType.val === 'IB' }"
                >In Bond</b-button
              >
            </b-button-group>
            <b-button variant="link" @click="showDutyExplainModal">
              <img
                src="/app/themes/jeroboams-2020/dist/images/info-dark.svg"
                class=""
              />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-row class="search-interface">
        <b-container>
          <b-row>
            <b-col
              cols="0"
              :md="noFilters ? 0 : 3"
              class="text-left"
              v-if="displayMode === 'normal' || !noFilters"
            >
              <div
                v-if="!noFilters"
                :class="{ 'filter-pane': true, in: filterPaneVisibleMobile }"
              >
                <b-row>
                  <b-col>
                    <h3>Filter By</h3>
                    <b-button class="close" @click="toggleFilters()">
                      x
                    </b-button>
                  </b-col>
                </b-row>

                <b-card
                  v-bind:class="{
                    inactive: searchTerm && searchTerm.length < 1,
                  }"
                  class="mb-2 search-filter"
                >
                  <h6 class="no-collapse-icon">Search for...</h6>
                  <div>
                    <b-form-input
                      class="form-input-rounded mb-2"
                      v-model="searchTerm"
                      @change="doSearch(true, true)"
                    ></b-form-input>

                    <b-link
                      v-if="totalActiveFilters > 0"
                      class="d-none d-md-inline-block f-right mb-2"
                      @click="doSearch(true, true)"
                    >
                      Clear Filters
                    </b-link>
                  </div>
                </b-card>

                <b-card
                  v-bind:class="{ inactive: !f.en }"
                  v-show="!f.hide"
                  class="mb-2 search-filter"
                  v-for="(f, field) in visibleFilters"
                  v-bind:key="field"
                >
                  <h6 @click="f.en = !f.en">
                    {{ f.label ? f.label : field }}
                  </h6>

                  <b-collapse :id="'collapse-' + field" v-model="f.en">
                    <div class="price-slider" v-if="f.type === 'range'">
                      <vue-slider
                        v-model="f.val"
                        :tooltip="'none'"
                        :min="f.min"
                        :max="f.max"
                        @change="doSearch(false, false)"
                      ></vue-slider>
                      <div class="price-label-min">
                        {{ f.min | currencyWhole }}
                      </div>
                      <div class="price-label-max">
                        {{ f.max | currencyWhole }}+
                      </div>
                      <div class="price-label-range">
                        {{ f.val[0] | currencyWhole }} -
                        {{ f.val[1] | currencyWhole
                        }}{{ f.val[1] == f.max ? "+" : "" }}
                      </div>
                    </div>

                    <div v-if="f.type === 'match'">
                      <b-form-input
                        class="form-input-rounded"
                        v-model="f.val"
                        @change="doSearch(false, true)"
                        @keyup="producerAutocomplete()"
                        :disabled="!f.en"
                      ></b-form-input>

                      <div class="producer-autocomplete-options">
                        <ul class="search-suggestions">
                          <li
                            v-for="(suggestion, index) in producerOpts"
                            :key="index"
                            @click="
                              filter.Producer.val = suggestion;
                              doSearch(false, true);
                            "
                          >
                            <a href="javascript:;">{{ suggestion }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div
                      v-if="
                        f.type === 'term' &&
                        aggs[field] &&
                        aggs[field].length > 0
                      "
                    >
                      <b-form-checkbox-group
                        stacked
                        :key="'checkbox-group-' + field"
                        :checked="
                          filter[field].val === false
                            ? [false]
                            : filter[field].val
                        "
                        :name="'checkbox-group-' + field"
                      >
                        <b-form-checkbox
                          @change="toggleTermFilter(field, entry.term)"
                          v-for="(entry, index) in aggs[field]"
                          :key="field + '-' + entry.term"
                          v-show="
                            entry.term.length > 0 &&
                            (index < 5 || aggs._state[field])
                          "
                          v-bind:class="{
                            'term-selected':
                              f.val !== false &&
                              f.val.indexOf(entry.term) !== -1,
                            'term-hidden':
                              !filter[field].show_empty && entry.count === 0,
                          }"
                          :value="entry.term"
                        >
                          {{ entry.term }} ({{ entry.count }})
                        </b-form-checkbox>
                      </b-form-checkbox-group>

                      <b-button
                        variant="link"
                        size="sm"
                        v-if="hasMoreTerms(field) && !aggs._state[field]"
                        @click="
                          aggs._state[field] = !aggs._state[field];
                          $forceUpdate();
                        "
                        >Show More...</b-button
                      >
                      <b-button
                        variant="link"
                        size="sm"
                        v-if="hasMoreTerms(field) && aggs._state[field]"
                        @click="
                          aggs._state[field] = !aggs._state[field];
                          $forceUpdate();
                        "
                        >Show Less...</b-button
                      >
                    </div>
                  </b-collapse>
                </b-card>

                <div class="filter-bar">
                  <button
                    class="btn btn-rounded btn-success"
                    @click="
                      doSearch(false, true);
                      toggleFilters();
                    "
                  >
                    Apply Filters
                  </button>
                  <button
                    class="btn btn-rounded btn-primary"
                    @click="
                      doSearch(true, true);
                      toggleFilters();
                    "
                  >
                    Clear All
                  </button>
                </div>
              </div>
            </b-col>
            <b-col md="9" class="search-result-list">
              <div v-if="performingSearch" class="search-msg-searching">
                <img
                  src="/app/themes/jeroboams-2020/dist/images/loader-200.svg"
                  class="mb-3"
                />
                <p>Please Wait...</p>
              </div>
              <div v-else-if="results.total === 0" class="search-msg-searching">
                <h4>No results found</h4>
                <p>
                  Sorry, we were unable to find products matching your search.
                </p>
                <p v-if="!noFilters">
                  Perhaps you were too specific? Why not
                  <a href="javascript:;" @click="doSearch(true, true)"
                    >clear your filters and try again</a
                  >?
                </p>
              </div>

              <div v-if="displayMode === 'tabular-bordeaux'">
                <search-table-bordeaux
                  :results="results"
                  :hide="performingSearch"
                >
                </search-table-bordeaux>
              </div>

              <div v-else-if="displayMode === 'tabular-burgundy'">
                <search-table-burgundy
                  :results="results"
                  :hide="performingSearch"
                >
                </search-table-burgundy>
              </div>

              <div v-else-if="displayMode === 'tabular-dp-bottle'">
                <search-table-dp-bottle
                  :results="results"
                  :hide="performingSearch"
                >
                </search-table-dp-bottle>
              </div>

              <div v-else-if="displayMode === 'tabular-finewine-case'">
                <search-table-finewine-case
                  :results="results"
                  :hide="performingSearch"
                >
                </search-table-finewine-case>
              </div>

              <div v-else-if="isTrade">
                <search-result-trade
                  @set-filter="searchForFilterOnly($event.field, $event.term)"
                  v-for="result in results.hits"
                  v-bind:key="result._id"
                  :hide="performingSearch"
                  :result="result"
                  :filters="filter"
                >
                </search-result-trade>
              </div>
              <div v-else-if="filter.DutyType.val === 'DP'">
                <search-result
                  @set-filter="searchForFilterOnly($event.field, $event.term)"
                  v-for="result in results.hits"
                  v-bind:key="result._id"
                  :hide="performingSearch"
                  :result="result"
                  :filters="filter"
                >
                </search-result>
              </div>

              <div v-else>
                <search-result-compact
                  @set-filter="searchForFilterOnly($event.field, $event.term)"
                  v-for="result in results.hits"
                  v-bind:key="result._id"
                  :hide="performingSearch"
                  :result="result"
                  :filters="filter"
                >
                </search-result-compact>
              </div>

              <b-row v-if="displayMode === 'normal' || !noFilters">
                <b-col class="search-footer mt-1">
                  <b-row>
                    <b-col cols="3" md="3" order="1" class="text-left">
                      <button @click="backToTop()" class="btn-back-to-top">
                        Top
                      </button>
                    </b-col>
                    <b-col order="3" order-md="2" class="search-pagination">
                      <b-pagination
                        v-if="
                          displayMode !== 'tabular-burgundy' &&
                          displayMode !== 'tabular-bordeaux'
                        "
                        v-model="pageNum"
                        :total-rows="results.total"
                        :per-page="perPage"
                        @input="changePage"
                        align="center"
                        limit="5"
                        size="sm"
                      ></b-pagination>
                    </b-col>
                    <b-col
                      cols="9"
                      md="auto"
                      order="2"
                      order-md="3"
                      class="text-right"
                      v-if="!noFilters"
                    >
                      <label for="search-per-page">Show</label>
                      <b-button
                        variant="link"
                        @click="
                          perPage = 20;
                          doSearch(false, true);
                        "
                        >20</b-button
                      >

                      <b-button
                        variant="link"
                        @click="
                          perPage = 40;
                          doSearch(false, true);
                        "
                        >40</b-button
                      >

                      <b-button
                        variant="link"
                        @click="
                          perPage = 60;
                          doSearch(false, true);
                        "
                        >60</b-button
                      >

                      <b-button
                        variant="link"
                        @click="
                          perPage = 100;
                          doSearch(false, true);
                        "
                        >100</b-button
                      >
                    </b-col>
                    <b-col
                      v-else
                      cols="9"
                      md="auto"
                      order="2"
                      order-md="3"
                    ></b-col>
                  </b-row>

                  <b-row> </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
    </div>
  </div>
</template>
<style lang="scss">
.term-hidden {
  display: none;
}

.term-selected {
  font-weight: bold;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.raw-data {
  background-color: lightgray;
  border-radius: 4px;
  padding: 10px;
  border: 1px solid gray;
}

.search-result {
  text-align: left;
}
</style>
<script>
/* global gtag */
import Axios from "axios";
import Config from "@/config/default.config.js";
// import Helpers from "../helpers/search.helper.js";
import { debounce, clone, cloneDeep, orderBy } from "lodash-es";
import Cookies from "js-cookie";
import Vue from "vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import SearchResult from "@/components/SearchResult";
import SearchResultCompact from "@/components/SearchResultCompact";
import SearchResultTrade from "@/components/SearchResultTrade";
import SearchTableBordeaux from "@/components/SearchTableBordeaux";
import SearchTableBurgundy from "@/components/SearchTableBurgundy";
import SearchTableFinewineCase from "@/components/SearchTableFinewineCase";
import SearchTableDpBottle from "@/components/SearchTableDpBottle";

import {
  PaginationPlugin,
  ButtonGroupPlugin,
  ImagePlugin,
} from "bootstrap-vue";

Vue.use(PaginationPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(ImagePlugin);

var jQuery = window.jQuery;

import { paramCase, pascalCase, sentenceCase } from "change-case";

export default {
  name: "SearchInterface",
  components: {
    VueSlider,
    SearchResult,
    SearchResultCompact,
    SearchResultTrade,
    SearchTableBordeaux,
    SearchTableBurgundy,
    SearchTableFinewineCase,
    SearchTableDpBottle
  },
  watch: {
    $route() {
      //console.log(to, from);
      if (!this.performingSearch) {
        this.refreshURL();
        this.doSearch(false, false, true);
      }
    },
    // filter: {
    //   handler: function() { this.updateURL() },
    //   deep: true
    // }
  },
  computed: {
    displayMode: {
      get() {
        if (this.overrideDisplayMode) {
          return this.overrideDisplayMode;
        }

        return window._searchConfig && window._searchConfig.display_mode
          ? window._searchConfig.display_mode
          : "normal";
      },
      set(mode) {
        this.overrideDisplayMode = mode;
      },
    },
    basket() {
      return this.$store.state.basket;
    },
    hideZeroCountRegions() {
      if (
        this.filter.Country.val.length > 0 ||
        this.filter.Region.val.length > 0
      ) {
        return true;
      }

      return false;
    },
    totalActiveFilters() {
      var n = 0;

      for (var i in this.filter) {
        if (
          this.filter[i].val.length > 0 &&
          i !== "DutyType" &&
          i !== "FineWine"
        ) {
          if (i === "CasePrice" || i === "BottlePrice") {
            if (
              this.filter[i].val[0] === this.filter[i].min &&
              this.filter[i].val[1] === this.filter[i].max
            )
              continue;
          }
          n++;
        }
      }

      return n;
    },
    visibleFilters() {
      var ret = {};

      for (var i in this.filter) {
        if (
          this.filter[i].duty === "*" ||
          this.filter[i].duty === this.filter.DutyType.val ||
          this.filter.DutyType.val === false
        ) {
          if (this.filter[i].only_mode === "trade") {
            if (this.isTrade) {
              ret[i] = this.filter[i];
            }
            continue;
          }

          if (this.filter[i].only_mode === "retail") {
            if (!this.isTrade) {
              ret[i] = this.filter[i];
            }
            continue;
          }

          ret[i] = this.filter[i];
        }
      }

      return ret;
    },
  },
  methods: {
    hasMoreTerms(field) {
      var termLength = 0;

      for (var i in this.aggs[field]) {
        if (this.aggs[field][i].count > 0 || this.filter[field].show_empty) {
          termLength++;
        }
      }

      if (Array.isArray(this.aggs[field]) && termLength > 5) {
        return true;
      }

      return false;
    },
    dispatchDutyChangeEvent(duty) {
      document.dispatchEvent(
        new CustomEvent("jb_duty_changed", { detail: duty })
      );
    },

    dispatchBreadcrumbEvent(breadcrumbs) {
      if (window._searchConfig && window._searchConfig.no_meta) {
        return;
      }
      document.dispatchEvent(
        new CustomEvent("jb_breadcrumb_changed", { detail: breadcrumbs })
      );
    },

    dispatchTitleEvent(title) {
      if (window._searchConfig && window._searchConfig.no_meta) {
        return;
      }
      document.dispatchEvent(
        new CustomEvent("jb_title_changed", { detail: title })
      );
    },
    showDutyExplainModal() {
      if (jQuery) {
        jQuery("#modal-duty-explain").modal("show");
      }
    },
    searchForFilterOnly(field, term) {
      this.resetFilters();
      this.filter[field].val = [term];
      this.filter[field].en = true;
      this.doSearch(false, true);
    },
    async loadAggregationTerms() {
      var aggs = await Axios.get(Config.wp.host + "/jbs/v1/filter-terms/", {
        params: { duty: this.filter.DutyType.val },
      });

      this.aggs = {};

      for (var field in aggs.data) {
        for (var i in aggs.data[field]) {
          if (!this.aggs[field]) this.aggs[field] = [];

          this.aggs[field].push({
            term: aggs.data[field][i]["term"],
            count: aggs.data[field][i]["count"],
          });
        }
      }

      this.aggs["_state"] = {};
    },
    producerAutocomplete: debounce(async function () {
      var producers = await Axios.get(
        Config.wp.host +
          "/jbs/v1/suggest-producer/?q=" +
          this.filter["Producer"].val
      );

      this.producerOpts = producers.data;

      return;
    }, 150),
    backToTop() {
      window.scrollTo(0, 0);
    },
    toggleFilters() {
      this.filterPaneVisibleMobile = !this.filterPaneVisibleMobile;
    },
    refreshURL() {
      if (
        window._searchConfig &&
        window._searchConfig.no_history &&
        !window._searchConfig.filter_string
      ) {
        return;
      }

      var parts = this.$route.path.replace(/\+/g, " ").split("/");

      if (window._searchConfig && window._searchConfig.filter_string) {
        parts = window._searchConfig.filter_string
          .replace(/\+/g, " ")
          .split("/");
        parts.unshift(
          window._searchConfig.duty_type === "IB" ? "buy-wine" : "broking"
        );
        parts.unshift("-");
      }

      if (parts.length < 1) {
        return;
      }

      for (var i in parts) {
        parts[i] = decodeURIComponent(parts[i]);
      }

      for (var k in this.filter) {
        if (k === "Country" || k === "Colour") continue;

        this.filter[k].en = false;
      }

      if (typeof jQuery !== "undefined") {
        jQuery("body")
          .removeClass("current-duty-ib")
          .removeClass("current-duty-dp");
      }

      switch (parts[1]) {
        case "buy-wine":
          this.searchFacade = "normal";
          this.filter.DutyType.val = "DP";
          if (typeof jQuery !== "undefined") {
            jQuery("body").addClass("current-duty-dp");
          }
          break;
        case "broking":
          this.searchFacade = "normal";
          this.filter.DutyType.val = "IB";
          if (typeof jQuery !== "undefined" && this.displayMode === "normal") {
            jQuery("body").addClass("current-duty-ib");
          } else if (
            typeof jQuery !== "undefined" &&
            this.displayMode !== "normal"
          ) {
            jQuery("body").removeClass("current-duty-ib");
            jQuery("body").addClass("current-duty-dp");
          }
          break;
        case "spirits":
          this.searchFacade = "spirits";
          this.filter.DutyType.val = "DP";
          this.filter.Colour.val = ["Spirit", "Cider", "Beer"];
          this.filter.Colour.en = true;
          if (typeof jQuery !== "undefined") {
            jQuery("body").addClass("current-duty-dp");
          }
          break;
        case "search":
        default:
          this.searchFacade = "normal";
          this.filter.DutyType.val = Cookies.get("last-duty-type");
          break;
      }

      this.filter.DutyType.en = true;
      this.filter.FineWine.en = true;

      if (parts[2] !== "-") {
        this.searchTerm = parts[2];
      }

      var filterParts = parts.slice(3);

      for (var n = 0; n < filterParts.length; n += 2) {
        filterParts[n] = pascalCase(sentenceCase(filterParts[n]));

        if (this.filter[filterParts[n]]) this.filter[filterParts[n]].en = true;

        if (
          filterParts[n] === "Page" ||
          filterParts[n] === "PerPage" ||
          filterParts[n] === "SortBy" ||
          filterParts[n] === "View"
        ) {
          if (filterParts[n] === "View") {
            this.displayMode = filterParts[n + 1];
          }

          if (filterParts[n] === "Page") {
            this.pageNum = filterParts[n + 1];
          }

          if (filterParts[n] === "PerPage") {
            this.perPage = filterParts[n + 1];
          }

          if (filterParts[n] === "SortBy") {
            this.sortBy = filterParts[n + 1];
          }

          continue;
        }

        if (filterParts[n] === "FineWine") {
          this.filter["FineWine"].val = filterParts[n + 1];
          continue;
        }

        if (filterParts[n] === "Price") {
          if (this.filter["DutyType"].val === "IB") {
            filterParts[n] = "CasePrice";
          } else {
            filterParts[n] = "BottlePrice";
          }
        }

        if (this.filter[filterParts[n]]) {
          if (
            filterParts[n + 1] === "-" ||
            (this.filter[filterParts[n]].duty !== "*" &&
              this.filter[filterParts[n]].duty !== this.filter["DutyType"].val)
          ) {
            if (
              filterParts[n] === "CasePrice" ||
              filterParts[n] === "BottlePrice"
            ) {
              this.filter["CasePrice"].en = false;
              this.filter["BottlePrice"].en = false;
            } else {
              this.filter[filterParts[n]].en = false;
            }

            continue;
          }

          if (this.filter[filterParts[n]].type === "range") {
            var r = filterParts[n + 1].split(",");
            this.filter[filterParts[n]].val = r;
            this.filter[filterParts[n]].en = true;
          } else if (this.filter[filterParts[n]].type === "match") {
            this.filter[filterParts[n]].val = filterParts[n + 1];
            this.filter[filterParts[n]].en = true;
          } else {
            this.filter[filterParts[n]].val = filterParts[n + 1].split(",");
            this.filter[filterParts[n]].en = true;
          }
        }
      }

      this.urlParts = parts;
      this.urlParts.shift();
    },
    updateURL() {
      if (window._searchConfig && window._searchConfig.no_history) {
        return;
      }

      if (typeof jQuery !== "undefined") {
        jQuery("body")
          .removeClass("current-duty-ib")
          .removeClass("current-duty-dp");
      }

      if (this.urlParts[0] !== "spirits") {
        this.urlParts = [];
        switch (this.filter["DutyType"].val) {
          case "IB":
            this.urlParts[0] = "broking";
            if (
              typeof jQuery !== "undefined" &&
              this.displayMode === "normal"
            ) {
              jQuery("body").addClass("current-duty-ib");
            } else if (
              typeof jQuery !== "undefined" &&
              this.displayMode !== "normal"
            ) {
              jQuery("body").removeClass("current-duty-ib");
            }
            break;
          case "DP":
            this.urlParts[0] = "buy-wine";
            if (typeof jQuery !== "undefined") {
              jQuery("body").addClass("current-duty-dp");
            }
            break;
        }
      } else {
        this.urlParts = [];
        this.urlParts[0] = "spirits";
        if (typeof jQuery !== "undefined") {
          jQuery("body").addClass("current-duty-dp");
        }
      }

      Cookies.set("last-duty-type", this.filter.DutyType.val);

      if (this.searchTerm && this.searchTerm.length > 0) {
        this.urlParts[1] = encodeURIComponent(this.searchTerm.replace("%", ""));
      } else {
        this.urlParts[1] = "-";
      }

      for (var field in this.filter) {
        if (this.filter[field].en) {
          if (field === "DutyType") {
            continue;
          }

          if (this.filter[field].val === false) {
            continue;
          }

          if (field === "FineWine" && this.filter[field].val.length === 0) {
            continue;
          }

          if (
            (field === "BottlePrice" && this.filter["DutyType"].val === "DP") ||
            (field === "CasePrice" && this.filter["DutyType"].val === "IB")
          ) {
            this.urlParts.push(paramCase("Price"));
            this.urlParts.push(
              encodeURIComponent(this.filter[field].val[0]) +
                "," +
                encodeURIComponent(this.filter[field].val[1])
            );
            continue;
          }

          if (field === "FineWine" && this.filter[field].val.length > 0) {
            this.urlParts.push(paramCase("FineWine"));
            this.urlParts.push(encodeURIComponent(this.filter[field].val));
            continue;
          }

          if (this.filter[field].type === "range") {
            this.urlParts.push(paramCase(field));
            this.urlParts.push(
              encodeURIComponent(this.filter[field].val[0]) +
                "," +
                encodeURIComponent(this.filter[field].val[1])
            );
            continue;
          }

          if (
            this.filter[field] &&
            this.filter[field].duty !== "*" &&
            this.filter[field].duty !== this.filter["DutyType"].val
          ) {
            this.filter[field].en = false;
            this.filter[field].val = false;
            continue;
          }

          if (field === "Colour" && this.searchFacade === "spirits") {
            //
          } else {
            this.urlParts.push(paramCase(field));
          }

          if (Array.isArray(this.filter[field].val)) {
            var encoded = this.filter[field].val.map((v) =>
              encodeURIComponent(v)
            );

            if (field === "Colour" && this.searchFacade === "spirits") {
              for (var i in encoded) {
                if (
                  encoded[i] === "Spirit" ||
                  encoded[i] === "Cider" ||
                  encoded[i] === "Beer"
                ) {
                  delete encoded[i];
                }
              }

              encoded = encoded.filter(Boolean);
              if (encoded.length > 0) {
                this.urlParts.push(paramCase(field));
                this.urlParts.push(encoded.join(","));
              }
            } else {
              this.urlParts.push(encoded.join(","));
            }
          } else {
            this.urlParts.push(encodeURIComponent(this.filter[field].val));
          }
        }
      }

      if (this.perPage !== 40) {
        this.urlParts.push(paramCase("PerPage"));
        this.urlParts.push(this.perPage);
      }

      if (this.pageNum > 1) {
        this.urlParts.push(paramCase("Page"));
        this.urlParts.push(this.pageNum);
      }

      if (this.sortBy !== "default") {
        this.urlParts.push(paramCase("SortBy"));
        this.urlParts.push(this.sortBy);
      }

      if (this.displayMode !== "normal") {
        this.urlParts.push(paramCase("View"));
        this.urlParts.push(this.displayMode);
      }

      if (
        this.$router.currentRoute.path.replace(/^\/|\/$/g, "") !==
          this.urlParts.join("/").replace(/^\/|\/$/g, "") &&
        this.$router.currentRoute.path !== undefined
      ) {
        this.$router.push("/" + this.urlParts.join("/") + "/");
      }
    },
    toggleTermFilter(filter, term) {
      if (this.filter[filter].val === false) this.filter[filter].val = [];

      if (this.filter[filter].val.indexOf(term) !== -1) {
        this.filter[filter].val.splice(
          this.filter[filter].val.indexOf(term),
          1
        );
      } else {
        this.filter[filter].en = true;
        this.filter[filter].val.push(term);
      }

      this.filter[filter].justModified = true;

      if (this.filter[filter].val.length === 0) {
        this.filter[filter].val = false;
      }

      if (this.aggs[filter] && this.filter[filter].val) {
        for (var i in this.aggs[filter]) {
          if (
            this.filter[filter].val.indexOf(this.aggs[filter][i].term) !== -1
          ) {
            this.aggs[filter][i].en = 1;
          } else {
            this.aggs[filter][i].en = 0;
          }
        }
        if (!this.firstLoad)
          this.aggs[filter] = orderBy(
            this.aggs[filter],
            ["en", "count"],
            ["desc", "desc"]
          );
      }

      if (!this.isMobileDevice()) this.doSearch();
      else this.doSearch(false, false, true, true);
    },
    changePage() {
      if (this.performingSearch) return;
      return this.doSearch(false, true);
    },
    changeSort() {
      this.pageNum = 1;
      return this.doSearch(false, true);
    },
    resetFilters() {
      let dt = clone(this.filter.DutyType);
      this.filter = cloneDeep(this.filterDefaults);
      this.filter.DutyType = dt;
    },
    doSearch: debounce(async function (
      clearFilters,
      scrollToTop,
      noUpdate,
      aggregationsOnly
    ) {
      this.performingSearch = true;

      this.tabIndex = 0;

      if (clearFilters) {
        this.resetFilters();
      }

      if (!noUpdate) this.updateURL();

      if (scrollToTop) {
        window.scrollTo(0, 0);
      }

      this.dispatchDutyChangeEvent(this.filter.DutyType.val);

      // this.results.total = 0;
      // this.results.hits = [];
      // this.results.max_score = 0;
      // this.results.took = 0;

      try {
        //this.lastQuery = Helpers.searchQuery(this.searchTerm, this.filter, this.pageNum, this.perPage, this.sortBy)

        this.lastQuery = {
          query: this.searchTerm,
          filters: this.filter,
          page: this.pageNum,
          per_page: this.perPage,
          sort_by: this.sortBy,
        };

        if (window._searchConfig && window._searchConfig.wcids) {
          // Promotion product list in wcids.

          // Unset duty filter.

          this.lastQuery["wcids"] = window._searchConfig.wcids;

          if (window._searchConfig.show_out_of_stock) {
            this.lastQuery["ignore_stock"] = true;
          }
        }

        var results = await Axios.post(Config.es.host, this.lastQuery);

        this.lastResponse = false;
        this.performingSearch = false;

        if (!aggregationsOnly) {
          this.results.total = results.data.total;
          this.results.hits = results.data.results;

          for (var j in this.results.hits) {
            this.results.hits[j]._source._add_qty = 1;
          }

          // this.results.max_score = results.data.hits.max_score;
          this.explainData = false;
          // this.results.took = results.data.took;
        }

        for (var i in results.data.aggregations) {
          if (!this.aggs[i]) {
            // this.aggs[i] = []
            // for(var j in results.data.aggregations[i].buckets) {
            //   this.aggs[i].push({term: results.data.aggregations[i].buckets[j].key, count: results.data.aggregations[i].buckets[j].doc_count})
            // }
            // console.error('Aggregations not loaded.');
          } else {
            // Already loaded the aggregations, so zero everything out, intersect new counts, and then reorder.
            // This allows the user to navigate freely across terms that may not be present with the current search params.

            for (var l in this.aggs[i]) {
              if (this.filter[i].val.length > 0) {
                if (this.filter[i].val.indexOf(this.aggs[i][l].term) !== -1) {
                  this.aggs[i][l].count = 0;
                }
              } else {
                this.aggs[i][l].count = 0;
              }
              this.aggs[i][l].en =
                (this.filter[i] &&
                  this.filter[i].val === this.aggs[i][l].term) ||
                (this.filter[i] &&
                  Array.isArray(this.filter[i].val) &&
                  this.filter[i].val.indexOf(this.aggs[i][l].term) !== -1)
                  ? 1
                  : 0;

              for (var k in results.data.aggregations[i].buckets) {
                if (
                  this.aggs[i][l].term ===
                  results.data.aggregations[i].buckets[k].key
                ) {
                  this.aggs[i][l].count =
                    results.data.aggregations[i].buckets[k].doc_count;
                }
              }
            }
            this.aggs[i] = orderBy(
              this.aggs[i],
              ["en", "count"],
              ["desc", "desc"]
            );
          }

          this.aggs._state[i] = false;
        }

        for (var m in this.filter) {
          if (this.filter[m].justModified) {
            delete this.filter[m].justModified;
          }
        }

        Cookies.set("last-search-url", this.$route.path);

        if (!window._searchConfig || !window._searchConfig.wcids) {
          if (results.data.breadcrumbs) {
            this.dispatchBreadcrumbEvent(results.data.breadcrumbs);
          }

          if (results.data.title) {
            this.dispatchTitleEvent(results.data.title);
          } else {
            this.dispatchTitleEvent("Shop");
          }
        }

        if (typeof gtag !== "undefined") {
          var catlist = results.data.breadcrumbs.map((x) => x[0]).join(",");

          gtag("config", process.env.GA_TRACKING_ID, {
            page_title: results.data.title ? results.data.title : "Shop",
            page_path:
              window.location.pathname +
              "?_gas=" +
              this.searchTerm +
              "&_gac=" +
              catlist,
          });

          var items = [];

          for (var p in results.data.results) {
            var categories = [];

            if (results.data.results[p]._source.SubRegion[0]) {
              categories.push(results.data.results[p]._source.SubRegion[0]);
            }

            if (results.data.results[p]._source.Region[0]) {
              categories.push(results.data.results[p]._source.Region[0]);
            }

            if (results.data.results[p]._source.Country[0]) {
              categories.push(results.data.results[p]._source.Country[0]);
            }

            if (results.data.results[p]._source.Colour[0]) {
              categories.push(results.data.results[p]._source.Colour[0]);
            }

            if (results.data.results[p]._source.Type) {
              categories.push(results.data.results[p]._source.Type);
            }

            // console.log(categories.join("/"));

            items.push({
              id: results.data.results[p]._id,
              name: results.data.results[p]._source.ItemDescription[0],
              list_name: "Search Results",
              list_position: (this.pageNum - 1) * this.perPage + (p + 1),
              brand: results.data.results[p]._source.Producer,
              currency: "GBP",
              category: categories.join("/"),
              variant: results.data.results[p]._source.DutyType,
              price:
                results.data.results[p]._source.DutyType === "DP"
                  ? results.data.results[p]._source.DP_Price
                  : results.data.results[p]._source.IB_Price,
            });
          }

          gtag("event", "view_item_list", { items });
        }
      } catch (e) {
        alert("Error performing search");
        //console.error(e);
        this.lastResponse = e;
        this.tabIndex = 3;
        this.performingSearch = false;
        this.results.took = false;
        this.results.total = 0;
        this.results.hits = [];
        // this.results.max_score = 0;
        this.explainData = false;
        // this.aggs = {
        //   _state: {}
        // };
      }
    },
    300),
  },
  created() {
    this.noFilters =
      window._searchConfig && typeof(window._searchConfig.no_filters) !== 'undefined'
        ? window._searchConfig.no_filters
        : false;
    this.filterDefaults = cloneDeep(this.filter);

    if (window._searchConfig && window._searchConfig.set_filters) {
      for (var i in window._searchConfig.set_filters) {
        this.filter[i].val = window._searchConfig.set_filters[i];
        this.filter[i].en = true;
        this.filterDefaults[i].en = true;
        this.filterDefaults[i].val = window._searchConfig.set_filters[i];
      }

      console.log(this.filter);
    }

    this.refreshURL();

    if (window._searchConfig && window._searchConfig.duty_type) {
      this.filter.DutyType.val = window._searchConfig.duty_type;
    }

    if (this.displayMode === "tabular-bordeaux") {
      this.sortBy = "bordeaux";
      this.perPage = 1000;
    }

    if (this.displayMode === "tabular-burgundy") {
      this.sortBy = "burgundy";
      this.perPage = 1000;
    }

    this.loadAggregationTerms().then(() => {
      this.doSearch();
      this.firstLoad = false;
      if (window.setFullPageLoader) {
        window.setFullPageLoader(false);
      }
    });
  },
  data: function () {
    return {
      priceSliderFormat: (v) => {
        if (v === 500 && this.filter.DutyType.val === "DP") return "£500 +";

        if (v === 1500 && this.filter.DutyType.val === "IB") return "£1500 +";

        return Vue.options.filters.currency(v);
      },
      producerOpts: [],
      producerQuery: "",
      searchFacade: "normal",
      firstLoad: true,
      formats: {},
      formatsLoading: false,
      filterPaneVisibleMobile: false,
      urlParts: [],
      tabIndex: 0,
      lastQuery: {},
      lastResponse: false,
      profilingData: [],
      profilingColours: [],
      pageNum: 1,
      perPage: 40,
      sortBy: "default",
      searchTerm: "",
      explainData: false,
      performingSearch: true,
      noFilters: false,
      overrideDisplayMode: false,
      results: {
        total: 0,
        hits: [], //,
        //max_score: null
      },
      aggs: {
        _state: {},
      },
      isPromoView: false,
      promoName: "",
      filterDefaults: {},
      filter: {
        DutyType: {
          en: true,
          duty: "*",
          type: "term",
          val: "DP",
          label: "Duty Type",
          hide: true,
        },
        FineWine: {
          en: true,
          duty: "*",
          type: "term",
          val: "",
          label: "Fine Wine",
          hide: true,
        },
        CasePrice: {
          en: false,
          duty: "IB",
          type: "range",
          min: 0,
          max: 1500,
          val: [0, 1500],
          label: "Price (Case)",
          only_mode: "retail",
        },
        BottlePrice: {
          en: false,
          duty: "DP",
          type: "range",
          min: 0,
          max: 500,
          val: [0, 500],
          label: "Price (Bottle)",
          only_mode: "retail",
        },
        PriceBracket: {
          en: false,
          duty: "DP",
          type: "term",
          val: false,
          label: "Price Bracket",
          only_mode: "trade",
        },
        Colour: {
          en: true,
          duty: "*",
          type: "term",
          val: false,
          show_empty: true,
        },
        Country: {
          en: true,
          duty: "*",
          type: "term",
          val: false,
          show_empty: true,
        },
        Region: {
          en: false,
          duty: "*",
          type: "term",
          val: false,
        },
        SubRegion: {
          en: false,
          duty: "*",
          type: "term",
          val: false,
          label: "Sub Region",
        },
        Vintage: {
          en: false,
          duty: "*",
          type: "term",
          val: false,
        },
        BottleSize: {
          en: false,
          duty: "*",
          type: "term",
          val: false,
          label: "Bottle Size",
        },
        // CaseSize: {
        //   en: false,
        //   duty: 'IB',
        //   type: "term",
        //   val: false,
        //   label: 'Case Size'
        // },

        Type: {
          en: false,
          duty: "DP",
          type: "term",
          val: false,
        },
        GrapeVariety: {
          en: false,
          duty: "*",
          type: "term",
          val: false,
          label: "Grape Variety",
        },
        Classification: {
          en: false,
          duty: "IB",
          type: "term",
          val: false,
        },
        OrganicStatus: {
          en: false,
          duty: "DP",
          type: "term",
          val: false,
          label: "Organic Status",
        },
        VeganVeg: {
          en: false,
          duty: "DP",
          type: "term",
          val: false,
          only_mode: "trade",
          label: "Vegetarian / Vegan",
        },
        StyleBody: {
          en: false,
          duty: "DP",
          type: "term",
          val: false,
          label: "Body",
        },
        StyleSweetness: {
          en: false,
          duty: "DP",
          type: "term",
          val: false,
          label: "Sweetness",
        },
        StyleExtra: {
          en: false,
          duty: "DP",
          type: "term",
          val: false,
          label: "Extra",
        },
        Producer: {
          en: false,
          duty: "*",
          type: "match",
          val: "",
        },
      },
    };
  },
};
</script>